import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzHlwn70 } from './pages'

type TIdToPageMapWoofzHlwn70 = Record<PageIdWoofzHlwn70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_HLWN_70: TIdToPageMapWoofzHlwn70 = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/subscriptions/SubscriptionHlwn70'
      ).then((m) => ({
        default: m.SubscriptionsHlwn70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/subscriptions/SubscriptionHlwn70'
      ),
  },
  [PageId.CHAT_UPSELL_HLWN_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_HLWN_70]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzHlwn70.DOWNLOAD_HLWN_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzHlwn70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
